import axios from "axios";
import { useQueries, UseQueryResult } from "react-query";
import { toast } from "react-toastify";
import { edcUrls, odcUrls, plantUrls } from "../../../URL/ApplicationUrls";
import { minutesAsMilliSeconds } from "../../../Utils/time";
import { SelectionListItem } from "../../../Forms/SelectionListItem";

export const useFetchDestinationTypeGsdbs = () => {
  const errorMessage = (locationTypeName: string): string =>
    `An error occurred when retrieving the ${locationTypeName} GSDBs`;

  const queries = [
    {
      queryKey: ["plantGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () =>
        fetchCollectionOf<SelectionListItem<string>>(plantUrls.selectableGsdbs.apiUrl),
      onError: () => toast.error(errorMessage("Plant")),
    },
    {
      queryKey: ["edcGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(edcUrls.selectableGsdbs),
      onError: () => toast.error(errorMessage("EDC")),
    },
    {
      queryKey: ["odcGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(odcUrls.selectableOdcGsdbs),
      onError: () => toast.error(errorMessage("ODC")),
    },
    {
      queryKey: ["epcGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(odcUrls.selectableEpcGsdbs),
      onError: () => toast.error(errorMessage("EPC")),
    },
  ];

  return useQueries<SelectionListItem<string>[]>([...queries]) as UseQueryResult<
    SelectionListItem<string>[]
  >[];
};

const fetchCollectionOf = async <T,>(url: string) => {
  const { data } = await axios.get<T[]>(url);
  return data;
};
